import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import ReviewApplication from '../../../modules/accessArrangment/components/candidate/ReviewApplication/ReviewApplication';
import ReviewAmendment from '../../../modules/accessArrangment/components/candidate/ReviewApplication/ReviewAmendment';

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    left: '-5%',
    marginTop: theme.spacing(9),
  },
}));

interface ReviewApplicationCoordinatorProps {
  routeSteps: { label: string }[];
  activeStep: number;
  title: string;
}

const ReviewApplicationCoordinator = ({
  routeSteps,
  activeStep,
  title,
}: ReviewApplicationCoordinatorProps) => {
  const { t } = useTranslation();
  const { mode, uuid } = useParams<{ mode: string; uuid: string }>();
  const { classes } = useStyles();

  const candidateNameNewApplication =
    localStorage.getItem(`candidateNameNewApplication: ${uuid}`) || '';
  const candidateNameContinueApplication =
    localStorage.getItem(`candidateNameContinueApplication: ${uuid}`) || '';

  const candidateNameAmendmentApplication =
    localStorage.getItem(`candidateNameAmendmentApplication: ${uuid}`) || '';

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <KeyValue
          keyText={t('accessArrangement->>CoordinatorSelectCandidate.CandidateName')}
          valueText={
            mode === 'amendment'
              ? candidateNameAmendmentApplication
              : candidateNameNewApplication || candidateNameContinueApplication
          }
        />
        <Box className={classes.stepper}>
          <Stepper activeStep={activeStep} steps={routeSteps} />
        </Box>
      </HeaderTemplate>
      {mode === 'draft' ? <ReviewApplication /> : <ReviewAmendment />}
    </>
  );
};

export default ReviewApplicationCoordinator;
